export default __webpack_public_path__ + "static/media/single_conv_mppt_topology_full.078b3ff7.png";